var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8392",
    "data-name": "Rectangle 8392",
    width: 22,
    height: 22,
    fill: "#05132e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11757",
    "data-name": "Path 11757",
    d: "M20.371,0H1.624A1.6,1.6,0,0,0,0,1.586V20.41A1.608,1.608,0,0,0,1.624,22H20.371A1.611,1.611,0,0,0,22,20.414V1.586A1.608,1.608,0,0,0,20.371,0ZM6.527,18.747H3.261V8.246H6.527ZM4.894,6.815A1.891,1.891,0,1,1,6.785,4.924,1.892,1.892,0,0,1,4.894,6.815ZM18.747,18.747H15.486v-5.1c0-1.216-.021-2.784-1.7-2.784-1.7,0-1.955,1.328-1.955,2.7v5.191H8.577V8.246H11.7V9.681h.043a3.427,3.427,0,0,1,3.085-1.7c3.3,0,3.914,2.174,3.914,5Z",
    fill: "#05132e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInIcon);
export default __webpack_public_path__ + "static/media/inIcon.7d5bd2fe77475b9169d9e91ab54de15c.svg";
export { ForwardRef as ReactComponent };